import { ReactNode } from "react";

export const MessageBot = ({ children, icon }: { children: ReactNode; icon: ReactNode }) => (
  <div className="message bot-message">
    {icon}
    {children}
  </div>
);
